export const environment = {
  production: true,
  beta: false,
  CATALOGUE: 'cessda',
  MATOMO_URL: 'https://providers.eosc-portal.eu/matomo/',
  MATOMO_SITE: 1,
  FAQ_ENDPOINT: '/faq/api',
  API_ENDPOINT: '/api',
  API_LOGIN: '/api/oauth2/authorization/eosc',
  API_LOGOUT: '/api/logout',
  STATS_ENDPOINT: 'https://providers.eosc-portal.eu/stats-api/',
  projectName: 'CESSDA',
  projectMail: 'support@sandbox.eosc-beyond.eu',
  serviceORresource: 'Service',
  hasUserConsent: true,
  privacyPolicyURL: 'assets/files/Privacy Policy – EOSC Innovation Sandbox -Service Catalogue.pdf',
  onboardingAgreementURL: './comingSoon',
  marketplaceServicesURL: './comingSoon',
  marketplaceDatasourcesURL: './comingSoon',
  marketplaceTrainingResourcesURL: './comingSoon',
  API_TOKEN_ENDPOINT: 'https://core-proxy.sandbox.eosc-beyond.eu/providers-api/',
  MONITORING_URL: './comingSoon',
  WS_ENDPOINT: ''
};
